if (!window.customElements.get('bikini-tirantes')) {
  const tirantesSelectionByForm = new Map();

  customElements.define('bikini-tirantes', class BikiniTirantes extends HTMLElement {
    constructor() {
      super();
      this.currencySymbol = '€';
    }

    connectedCallback() {
      this.formId = this.dataset.formId;

      this.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('.product-groups__tirantes') && e.target.classList.contains('product-groups__variant-input')) {
          this.handleTirantesChange(e);
        }
      });

      this.boundOnSubmit = this.handleFormSubmit.bind(this);
      document.addEventListener('submit', this.boundOnSubmit, true);

      this.boundOnVariantChange = () => this.applyMainPrice();
      document.addEventListener('variant:change', this.boundOnVariantChange);

      this.restoreSelection();

      const checked = this.querySelector('.product-groups__tirantes .product-groups__variant-input:checked');
      if (checked) this.handleTirantesChange({ target: checked });
    }

    restoreSelection() {
      const prev = tirantesSelectionByForm.get(this.formId);
      if (prev !== 'yes') return;
      const yesInput = this.querySelector('.product-groups__tirantes input[data-tirantes="yes"]');
      const noInput = this.querySelector('.product-groups__tirantes input[data-tirantes="no"]');
      if (!yesInput || !noInput) return;
      yesInput.checked = true;
      noInput.checked = false;
      const yesLabel = this.querySelector(`label[for="${yesInput.id}"]`);
      const noLabel = this.querySelector(`label[for="${noInput.id}"]`);
      if (yesLabel) yesLabel.classList.add('is-selected');
      if (noLabel) noLabel.classList.remove('is-selected');
    }

    disconnectedCallback() {
      if (this.boundOnSubmit) document.removeEventListener('submit', this.boundOnSubmit, true);
      if (this.boundOnVariantChange) document.removeEventListener('variant:change', this.boundOnVariantChange);
    }

    parsePriceText(text) {
      if (!text) return null;
      const cleaned = text.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
      const num = parseFloat(cleaned);
      return isNaN(num) ? null : Math.round(num * 100);
    }

    applyMainPrice() {
      const el = document.querySelector('.price-list--product sale-price');
      if (!el) return;

      let base;
      if (el.dataset.baseCents != null) {
        base = parseInt(el.dataset.baseCents, 10);
      } else {
        base = this.parsePriceText(el.textContent);
        if (base == null) return;
        el.dataset.baseCents = String(base);
      }

      const yesChecked = this.querySelector('.product-groups__tirantes input[data-tirantes="yes"]:checked');
      const tirantesCents = yesChecked ? (parseInt(yesChecked.dataset.price, 10) || 0) : 0;
      const total = base + tirantesCents;
      const srOnly = el.querySelector('.sr-only');
      const srHtml = srOnly ? srOnly.outerHTML : '';
      el.innerHTML = `${srHtml}${this.formatMoney(total)}`;
    }

    handleTirantesChange(e) {
      const tirantesDetails = e.target.closest('.product-groups__tirantes');
      const priceLabel = tirantesDetails?.querySelector('.product-groups__price');
      if (priceLabel && e.target.dataset.price !== undefined) {
        const price = parseInt(e.target.dataset.price, 10) || 0;
        priceLabel.textContent = this.formatMoney(price);
      }
      tirantesSelectionByForm.set(this.formId, e.target.dataset.tirantes === 'yes' ? 'yes' : 'no');
      this.applyMainPrice();
    }

    async handleFormSubmit(e) {
      const form = e.target;
      const formId = form?.getAttribute?.('id');
      if (!form || formId !== this.formId) return;

      const tirantesYesInput = this.querySelector('.product-groups__tirantes input[data-tirantes="yes"]:checked');
      if (!tirantesYesInput || !tirantesYesInput.value) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      this.form = form;
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      if (!mainVariantId) return;

      const mainQuantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);

      const mainProperties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) mainProperties[match[1]] = value;
      }

      const tirantesProperties = {
        _tirantesProductId: tirantesYesInput.value
      };
      if (mainProperties._parentProductId) tirantesProperties._parentProductId = mainProperties._parentProductId;
      if (mainProperties._parentProductHandle) tirantesProperties._parentProductHandle = mainProperties._parentProductHandle;

      const items = [
        { id: parseInt(mainVariantId, 10), quantity: mainQuantity, properties: mainProperties },
        { id: parseInt(tirantesYesInput.value, 10), quantity: mainQuantity, properties: tirantesProperties }
      ];
      
      const submitButtons = Array.from(this.form.elements).filter((el) => el.type === 'submit');
      submitButtons.forEach((btn) => btn.setAttribute('aria-busy', 'true'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sectionsToBundle.join(',') })
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.description || 'Could not add to cart');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent['sections'] = responseJson['sections'];

        this.form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: responseJson.items || [responseJson], cart: cartContent, onSuccessDo: 'force_open_drawer' }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        this.form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } }));
        console.error('[bikini-tirantes] error:', error);
      } finally {
        submitButtons.forEach((btn) => btn.removeAttribute('aria-busy'));
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    formatMoney(cents) {
      const format = (typeof theme !== 'undefined' && theme.moneyFormat) || window.themeVariables?.shop?.moneyFormat || '{{amount}} €';
      if (window.Shopify?.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      if (typeof theme !== 'undefined' && theme.Currency?.formatMoney) {
        return theme.Currency.formatMoney(cents, format);
      }
      return `${(cents / 100).toFixed(2).replace('.', ',')} ${this.currencySymbol}`;
    }
  });
}
